import {
  Component,
  ChangeDetectionStrategy,
  Renderer2,
  ElementRef,
  OnInit,
  model,
  output,
  inject,
  input,
} from '@angular/core';
import { SidebarLogoComponent } from './partials/sidebar-logo/sidebar-logo.component';
import { SidebarMenuComponent } from './partials/sidebar-menu/sidebar-menu.component';
import { MenuItemInterface } from '../../types';

@Component({
  selector: 'ui-sidebar',
  imports: [SidebarLogoComponent, SidebarMenuComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent implements OnInit {
  private renderer = inject(Renderer2);
  private el = inject(ElementRef);

  PAGE_ROUTES = model.required<{ [key: string]: string }>();
  menuItems = model.required<MenuItemInterface[]>();
  logoUrl = input<string>();
  logoMinUrl = input<string>();
  lockedItemClick = output<void>();

  ngOnInit() {
    this.initializeClasses();
  }

  initializeClasses() {
    const sidebarElement = this.el.nativeElement;
    this.renderer.addClass(sidebarElement, 'app-sidebar');
    this.renderer.addClass(sidebarElement, 'flex-column');
  }
}
